import React from "react";
import InputRange from "react-input-range";
import styles from "./RangeInput.scss";

export class RangeInput extends React.PureComponent {
  render() {
    const { style, ...props } = this.props;
    return (
      <div className={styles.RangeInput} style={style}>
        <InputRange {...props} />
      </div>
    );
  }
}
